/* tslint:disable */

declare var Object: any;
export interface StoragePayrollInterface {
  "id"?: number;
}

export class StoragePayroll implements StoragePayrollInterface {
  "id": number;
  constructor(data?: StoragePayrollInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StoragePayroll`.
   */
  public static getModelName() {
    return "StoragePayroll";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StoragePayroll for dynamic purposes.
  **/
  public static factory(data: StoragePayrollInterface): StoragePayroll{
    return new StoragePayroll(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StoragePayroll',
      plural: 'StoragePayrolls',
      path: 'StoragePayrolls',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StoragePayroll.ts